import { capworksProgramService } from "@/modules/capworks/store/services/capworks-program-service";
import { LENDING_PROGRAM_SERVICE_TAG } from "@/features/LendingProgram/utils/lendingProgramServiceTags";

const getLendingProgramEndpoint = capworksProgramService.injectEndpoints({
  endpoints: (builder) => ({
    getLendingProgram: builder.query({
      query: (lendingProgramId) => `lending-programs/${lendingProgramId}`,
      providesTags: ({ lendingProgramId }) => [
        { type: LENDING_PROGRAM_SERVICE_TAG, id: lendingProgramId },
      ],
    }),
  }),
  overrideExisting: false,
});

export const { useGetLendingProgramQuery } = getLendingProgramEndpoint;

